import { Button } from '@nf/ui';
import { PinIcon } from '@/components/icons/svg-icons';
import { useAccountInfo } from '@/hooks/query/account';
import { UIEvent, useEffect, useState } from 'react';
import { AccountActStatus } from '@nf/utils-common/constants';
import { useAnalyseAttribute } from '@/features/next-analyse';

type PinButtonProps = {
    isActive: boolean,
    clickHandler: (event: UIEvent) => void
};
export const PinButton = ({ isActive, clickHandler }: PinButtonProps) => {
	const { user } = useAccountInfo();
	const [isVisible, setIsVisible] = useState<boolean>(user?.ActStatus === AccountActStatus.Deposited);
	const taggedElement = useAnalyseAttribute('use-bet-type-pin');
	useEffect(() => {
		const currentIsVisible = user?.ActStatus === AccountActStatus.Deposited;
		if (currentIsVisible !== isVisible) {
			setIsVisible(currentIsVisible);
		}
	}, [user?.ActStatus]);
	return !isVisible ? null : (
		<Button
			variant="icon"
			data-active={isActive}
			onClick={clickHandler}
			ref={taggedElement}
		>
			<PinIcon />
		</Button>
	);
};